import { Component, Input, Output, EventEmitter, HostListener, ElementRef, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-multi-select-modal',
  templateUrl: './multi-select-modal.component.html',
  styleUrls: ['./multi-select-modal.component.css']
})
export class MultiSelectComponent {
  @Input() options: string[] = [];
  @Input() defaultOptions: string[] = [];
  @Output() selectedOptions: EventEmitter<string[]> = new EventEmitter();

  selectedItems: string[] = [];
  isDropdownVisible: boolean = false;

  toggleDropdown(): void {
    this.isDropdownVisible = !this.isDropdownVisible;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.defaultOptions) {
      this.selectedItems = [...this.defaultOptions];
    }
  }

  toggleSelection(option: string): void {
    if (this.selectedItems.includes(option)) {
      this.selectedItems = this.selectedItems.filter(item => item !== option);
    } else {
      this.selectedItems.push(option);
    }
    this.selectedOptions.emit(this.selectedItems);
  }

  @HostListener('document:click', ['$event'])
  handleClick(event: Event): void {
    // Close the dropdown if the click is outside the component
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.isDropdownVisible = false;
    }
  }

  ngAfterViewInit(): void {
    // Initialize selectedItems with the default selected options
    this.selectedItems = [...this.defaultOptions];
  }

  constructor(private elementRef: ElementRef) { }
}
